import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { IoChevronBackCircleOutline } from "react-icons/io5";
import instance from "../../api/api";

function DetailCommune() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [detailCommune, setDetailCommune] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const getDetailCommune = async () => {
      try {
        const response = await instance.get(`/municipalite/${id}`);
        const ville = response.data.data;
        setDetailCommune(ville);
        setIsLoading(false);
      } catch (error) {
        console.error("Une erreur s'est produite : ", error);
        setIsLoading(false);
      }
    };
    getDetailCommune();
  }, [id]);

  if (isLoading)
    return (
      <div className="flex justify-center items-center min-h-screen bg-gray-50">
        <div className="animate-pulse text-gray-600 text-lg font-medium">
          Chargement...
        </div>
      </div>
    );

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 py-10 px-4 sm:px-10">
      <div className="max-w-3xl mx-auto bg-white shadow-xl rounded-2xl p-6 sm:p-10 relative">
        <div className="flex items-center mb-6">
          <button onClick={() => navigate(-1)}>
            <IoChevronBackCircleOutline className="text-3xl mr-2" />
            <span className="text-sm font-medium">Retour</span>
          </button>
        </div>

        {detailCommune && (
          <>
            {/* <div className="border-b border-gray-200 pb-4 mb-6">
              <h1 className="text-2xl font-semibold text-gray-800">
                Commune de{" "}
                <span className="text-blue-600">{detailCommune.name}</span>
              </h1>
              <p className="text-sm text-gray-500 mt-1">
                Informations détaillées sur la commune sélectionnée.
              </p>
            </div> */}

            <div className="bg-blue-50 border border-blue-100 rounded-xl p-5 transition hover:shadow-md">
              <p className="text-gray-700 text-lg">
                <span className="font-semibold text-blue-800">Nom :</span>{" "}
                {detailCommune.name}
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default DetailCommune;
